import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const PaymentHistory = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-gray-50 min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-grow container mx-auto p-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 p-2 rounded-full hover:bg-gray-200"
          >
            <FaArrowLeft size={22} />
          </button>
          Payment History
        </h2>

        <div className="flex flex-col items-center justify-center bg-white py-16 px-6 rounded-xl shadow-md text-center">
          <img
            src="https://cdn-icons-png.flaticon.com/512/4781/4781517.png"
            alt="Stopwatch Icon"
            className="w-24 h-24 mb-6"
          />
          <h3 className="text-3xl font-semibold text-gray-800 mb-4">
            Coming Soon
          </h3>
          <p className="text-gray-600 text-lg">
            This feature is under development. Stay tuned for updates on your payment history.
          </p>
          <p className="mt-2 text-orange-500 font-medium">Team Infuber 🚀</p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentHistory;
